import { render, staticRenderFns } from "./ProjectAreaForm.vue?vue&type=template&id=3320578a&scoped=true&"
import script from "./ProjectAreaForm.vue?vue&type=script&lang=js&"
export * from "./ProjectAreaForm.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAreaForm.vue?vue&type=style&index=0&id=3320578a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3320578a",
  null
  
)

export default component.exports